module.exports = __webpack_public_path__ + "static/media/feed3.4d49b133.jpg";